import React, { useState } from "react";
import { Box, Typography, Tabs, Tab, Card } from "@mui/material";

import { useSelector } from "react-redux";

import { useGetCountsQuery, useGetItemsQuery } from "../../api/services/shopkeeperApi";
import { useDebounce } from "../../hooks/useDebounce";
import { useAppSelector } from "../../store/hooks";
import { SHOPKEEPER_STATUS } from "../../constants";
import SpareTable from "./spareTable";
import BackdropLoader from "../../components/common/BackdropLoader";

// Types
// interface RequestData {
//   Spare_ID: string;
//   id: string;
//   requester: string;
//   requestedDate: string;
//   approver: string;
//   approvalDate: string;
//   materialName: string;
//   quantity: number;
//   availability: number;
//   status: ShopkeeperStatus;
//   operations: Operation[];
//   remarks?: string;
//   deliveryStatus?: string;

//   //  "Spare_ID":number,
//   //           "Notification_UID": number;
//   //           "Requested_By": string;
//   //           "Requested_Date": string;
//   //           "Material_Code": string;
//   //           "Material_Name": string;
//   //           "Quantity_requested": number;
//   //           "Availability": null
//   //           "status": ShopkeeperStatus
// }

// interface Operation {
//   operationId: string;
//   operationName: string;
//   materialNumber: string;
//   materialName: string;
//   quantity: number;
//   status: "ISSUED" | "REJECTED";
// }

// Styled components
// const SearchContainer = styled(Box)<{ theme: any }>(({ theme }) => ({
//   position: "relative",
//   display: "flex",
//   alignItems: "center",
//   width: 220,
//   gap: theme.spacing(1),
//   borderRadius: 8,
//   border: `1px solid ${theme.palette.grey[300]}`,
//   backgroundColor: theme.palette.background.paper,
//   transition: "border-color 0.2s ease, box-shadow 0.2s ease",
//   "&:hover": {
//     borderColor: theme.palette.grey[400],
//   },
//   "&:focus-within": {
//     borderColor: theme.palette.primary.main,
//     boxShadow: `0 0 0 2px ${theme.palette.primary.main}20`,
//   },
//   "& .MuiInputBase-root": {
//     width: "100%",
//     paddingLeft: theme.spacing(4),
//     borderRadius: theme.shape.borderRadius,
//     border: `1px solid ${theme.palette.grey[300]}`,
//     "&:focus-within": {
//       borderColor: theme.palette.primary.main,
//       boxShadow: `0 0 0 2px ${theme.palette.primary.main}20`,
//     },
//   },
// }));

// const SearchIconWrapper = styled(Box)(({ theme }) => ({
//   position: "absolute",
//   left: theme.spacing(1.5),
//   top: "50%",
//   transform: "translateY(-50%)",
//   color: theme.palette.grey[400],
//   zIndex: 1,
// }));

// const StatusChip = styled(Chip)<{ status: string }>(({ status }) => {
//   // const normalized = status.toLowerCase();

//   return {
//     fontSize: "0.75rem",
//     fontWeight: 500,
//     borderRadius: "8px",
//     textTransform: "capitalize",
//     backgroundColor:
//       status ===  SHOPKEEPER_STATUS.PENDING
//         ? "#E3F2FD"
//         : status ===  SHOPKEEPER_STATUS.ISSUED
//         ? "#E8F5E9"
//         : "#FFEBEE",
//     color:
//       status ===  SHOPKEEPER_STATUS.PENDING
//         ? "#1565C0"
//         : status ===  SHOPKEEPER_STATUS.ISSUED
//         ? "#2E7D32"
//         : "#C62828",
//     "& .MuiChip-icon": {
//       color:
//         status ===  SHOPKEEPER_STATUS.PENDING
//           ? "#1565C0"
//           : status ===  SHOPKEEPER_STATUS.ISSUED
//           ? "#2E7D32"
//           : "#C62828",
//       fontSize: "0.6rem",
//       marginLeft: 6,
//     },
//   };
// });

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//   "&:hover": {
//     backgroundColor: theme.palette.grey[50],
//     cursor: "pointer",
//   },
//   transition: "background-color 0.2s",
// }));

// Request Detail Component

// Main Dashboard Component
const ShopkeeperDashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);
  // const [counts, setCounts] = useState({
  //   pending: 0,
  //   approved: 0,
  //   rejected: 0,
  // });
  const tabStatusMap: Record<
    number,
    "PENDING" | "ISSUED" | "REJECTED" | "ALL"
  > = {
    0: "ALL", // ALL
    1: SHOPKEEPER_STATUS.PENDING,
    2: SHOPKEEPER_STATUS.ISSUED,
    3: SHOPKEEPER_STATUS.REJECTED,
  };

  const { dateRange, rowsPerPage, currentPage, searchTerm } = useSelector(
    (state: any) => state.table
  );

  const [fromDate, toDate] = dateRange;

  const status = tabStatusMap[activeTab];
  const debouncedSearch = useDebounce(searchTerm, 500);
  const { PLANTNAME: plantName }: any = useAppSelector(
    (state: any) => state?.auth?.user?.plantDetails
  );
    const { data: countsData } = useGetCountsQuery({
    plant: plantName,
    fromDate: fromDate || undefined,
    toDate: toDate || undefined,
  });
  const { data, isLoading, isFetching } = useGetItemsQuery({
    status,
    page: currentPage,
    limit: rowsPerPage,
    search: debouncedSearch || undefined,
    fromDate: fromDate || undefined,
    toDate: toDate || undefined,
    plant: plantName,
  });

  // console.log("STATUS", status, data);
  
  // useEffect(() => {
  //   if (status === "ALL" && data?.items) {
  //     const pending = data.items.filter(
  //       (d: any) => d.status === SHOPKEEPER_STATUS.PENDING
  //     ).length;

  //     const approved = data.items.filter(
  //       (d: any) => d.status === SHOPKEEPER_STATUS.ISSUED
  //     ).length;

  //     const rejected = data.items.filter(
  //       (d: any) => d.status === SHOPKEEPER_STATUS.REJECTED
  //     ).length;

  //     setCounts({ pending, approved, rejected });
  //   }
  // }, [status, data]);

  const tabs = [
    { label: "All Request", count: null },
    {
      label: "Pending request",
      count: countsData?.count.PENDING || null,
    },
    { label: "Approved request", count: null },
    { label: "Rejected request", count: null },
  ];

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "grey.50" }}>
      <BackdropLoader openStates={isLoading || isFetching} />

      <Box sx={{ p: { xs: 2, sm: 3 }, mx: "auto" }}>
        {/* {!selectedRequest && ( */}
        <Card
          elevation={0}
          sx={{ backgroundColor: "white", borderRadius: 1, mb: 2, p: 3 }}
        >
          <Typography variant="h5" sx={{ fontWeight: 600, mb: 0.5 }}>
            Shopkeeper Dashboard
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontSize: 13, mb: 3 }}
          >
            Manage and monitor all empty embarkations in one place
          </Typography>

          <Box sx={{ borderBottom: 1, borderColor: "grey.200" }}>
            <Tabs
              value={activeTab}
              onChange={(_, newValue) => {
                setActiveTab(newValue);
              }}
              sx={{
                "& .MuiTab-root": {
                  textTransform: "none",
                  fontSize: "0.875rem",
                  fontWeight: 500,
                  color: "grey.600",
                  minHeight: "auto",
                  pb: 2,
                  "&.Mui-selected": {
                    color: "primary.main",
                  },
                },
                "& .MuiTabs-indicator": {
                  backgroundColor: "primary.main",
                  height: 2,
                },
              }}
            >
              {tabs.map((tab, index) => (
                <Tab
                  key={index}
                  label={
                    <Box>
                      {tab.label}
                      {tab.count !== null && ` (${tab.count})`}
                    </Box>
                  }
                />
              ))}
            </Tabs>
          </Box>
        </Card>

        {/* Table content */}
        <SpareTable
          data={data?.items ?? []}
          status={status ? status : "all"}
          isLoading={isLoading}
        />
      </Box>
    </Box>
  );
};

export default ShopkeeperDashboard;
